<template>
  <div class="competence-picker form-group">
    <label class="form-label">{{ label }}</label>
    <div class="input-group">
      <button class="btn btn-neutral btn-action btn-icon input-group-btn tooltip"
              data-tooltip="Mês anterior" aria-label="Mês anterior"
              :disabled="disabled" @click="shift(-1)">
        <fa-icon :icon="['fal', 'chevron-left']"/>
      </button>
      <span v-if="disabled"
            class="input-group-addon competence-value competence-value-static">
        <span class="competence-month">{{ monthLabel }}</span>
      </span>
      <dx-dropdown v-else ref="dropdown"
                   class="input-group-addon competence-value"
                   :items="options" label="text" direction="left"
                   @select="select" @keydown.native="onKeydown">
        <span class="competence-month">{{ monthLabel }}</span>
        <template slot="item" slot-scope="{ item }">
          <a href="#" class="competence-option"
             :class="{'is-selected': item.value === value}" @click.prevent>
            {{ item.text }}
            <fa-icon :icon="['fal', 'check']" v-if="item.value === value"/>
          </a>
        </template>
      </dx-dropdown>
      <button class="btn btn-neutral btn-action btn-icon input-group-btn tooltip"
              data-tooltip="Próximo mês" aria-label="Próximo mês"
              :disabled="disabled || isCurrent" @click="shift(1)">
        <fa-icon :icon="['fal', 'chevron-right']"/>
      </button>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { competenceLabel, competenceShortLabel } from '../service';

export default {
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: 'Competência dos lotes',
    },
    months: {
      type: Number,
      default: 12,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    monthLabel() {
      return competenceShortLabel(this.value);
    },
    isCurrent() {
      return this.value >= moment().format('YYYY-MM');
    },
    options() {
      const now = moment();
      return Array.from({ length: this.months }, (_, index) => {
        const competence = now.clone().subtract(index, 'month').format('YYYY-MM');
        return { value: competence, text: competenceLabel(competence) };
      });
    },
  },
  methods: {
    shift(amount) {
      if (this.disabled || (amount > 0 && this.isCurrent)) {
        return;
      }
      this.$emit('input', moment(this.value, 'YYYY-MM').add(amount, 'month').format('YYYY-MM'));
    },
    select({ value }) {
      this.$emit('input', value);
    },
    onKeydown(event) {
      if (event.target.closest('.menu')) {
        return;
      }
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.shift(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.shift(1);
      } else if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.$refs.dropdown.toggle();
      }
    },
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/_variables.scss";
.competence-picker {
  flex: 0 0 auto;
  margin-bottom: 0;
  .input-group {
    .btn.btn-neutral {
      background-color: $light-color;
      color: $gray-color-dark;
      height: $control-size;
      width: $control-size;
      &:hover {
        background-color: $gray-color-ultra-light;
        color: $primary-color;
      }
      &:focus {
        border-color: $secondary-color-light;
        box-shadow: none;
      }
    }
    .competence-value {
      background-color: $light-color;
      border-color: $border-color-dark;
      &.active,
      &:focus-within {
        border-color: $secondary-color-light;
        z-index: $zindex-0 + 1;
      }
      &.dropdown {
        padding: 0;
      }
    }
    .competence-value.dropdown > a,
    .competence-value-static {
      align-items: center;
      color: $body-font-color;
      display: flex;
      gap: $layout-spacing-sm;
      justify-content: center;
      min-width: 5rem;
      padding: 0 $layout-spacing;
      &:focus {
        box-shadow: none;
      }
      .competence-month {
        font-size: $font-size;
        font-weight: 600;
        white-space: nowrap;
      }
    }
    .competence-value.dropdown > a {
      height: $control-size - $border-width * 2;
    }
    .competence-value-static {
      color: $gray-color;
      height: $control-size;
    }
    .competence-value.dropdown > a:hover {
      background-color: $gray-color-ultra-light;
    }
    .competence-value-static {
      background-color: $bg-color-dark;
      color: $gray-color;
      cursor: not-allowed;
    }
    .menu {
      min-width: 7.5rem;
      .competence-option {
        align-items: center;
        display: flex;
        gap: $layout-spacing;
        justify-content: space-between;
        svg {
          font-size: $font-size-sm;
        }
        &.is-selected {
          font-weight: 600;
        }
      }
    }
  }
  @media screen and (max-width: $size-sm) {
    flex: 1 1 100%;
    .input-group {
      width: 100%;
      .competence-value {
        flex: 1 1 auto;
      }
      .menu {
        width: 100%;
      }
    }
  }
}
</style>
